<template>
  <PlaceholderPantalla
    titulo="Cuentas por Pagar"
    subtitulo="Gestión de obligaciones de pago con proveedores"
    descripcion="Administra todas tus cuentas y facturas pendientes de pago a proveedores. Programa pagos, registra pagos parciales o totales, recibe alertas de vencimiento, y mantén un calendario visual de todos tus compromisos de pago para una mejor planeación del flujo de efectivo."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../PlaceholderPantalla.vue'

const funcionalidades = [
  'Registrar facturas y obligaciones de pago con proveedores',
  'Programar fechas de pago con recordatorios automáticos',
  'Registrar pagos parciales o totales (actualiza saldo pendiente)',
  'Calendario visual de pagos programados del mes',
  'Alertas de facturas próximas a vencer (configurables)',
  'Priorización de pagos por importancia o beneficios (descuentos)',
  'Aplicar descuentos por pronto pago automáticamente',
  'Filtrar por estado: Pendiente, Programada, Parcial, Pagada, Vencida',
  'Dashboard con total por pagar, vencido, programado',
  'Análisis de proveedores: Mejores términos de pago, descuentos',
  'Generar proyección de salidas de efectivo',
  'Historial completo de pagos realizados',
  'Adjuntar facturas y comprobantes de pago',
  'Exportar reportes y calendario de pagos'
]

const datosManejados = [
  'Proveedor (nombre, contacto, términos de pago)',
  'Monto total de la factura',
  'Monto pagado',
  'Saldo pendiente de pago',
  'Fecha de recepción de factura',
  'Fecha de vencimiento',
  'Fecha programada de pago',
  'Días para vencimiento o atraso',
  'Estado (Pendiente, Programada, Parcial, Pagada, Vencida)',
  'Número de factura del proveedor',
  'Concepto y descripción',
  'Cuenta bancaria para realizar el pago',
  'Descuentos por pronto pago',
  'Historial de pagos efectuados',
  'Prioridad de pago',
  'Documentos adjuntos (facturas, pedidos)'
]
</script>
